import React from "react";
import InputLabel from "./InputLabel";
import InputWrapper from "./InputWrapper";
import styled from "styled-components";
import { color } from "../templates/ui";
import { getAppThemeName } from "../../Services/appTheme";
const StyledInfoField = styled.div `
    border: 1px solid ${color.gray.light};
    border-radius: ${(props) => (props.appTheme === "invoned" ? "8px" : "4px")};
    padding: 20px;
`;
const StyledIcon = styled.span `
    display: inline-block;
    margin-right: 10px;

    svg {
        fill: ${(props) => props.theme.primary};
        width: 25px;
        height: 25px;
        vertical-align: middle;
    }
`;
const StyledText = styled.span `
    vertical-align: middle;
    color: ${(props) => props.theme.textDark};
`;
const CurrentSessionInfoField = ({ children, label, icon, maxWidth, }) => (React.createElement(InputWrapper, { maxWidth: maxWidth },
    React.createElement(InputLabel, null, label),
    React.createElement(StyledInfoField, { appTheme: getAppThemeName() },
        React.createElement(StyledIcon, null, icon),
        React.createElement(StyledText, null, children))));
export default CurrentSessionInfoField;
